// @ts-nocheck

import React, { useCallback } from 'react';
import styled from 'styled-components';

import StarSvgAsComponent from '../../assets/svg/asComponents/StarSvgAsComponent';

const Button = styled.button`
  && {
    margin: 0;
    padding: 0;
    line-height: 1;
    background: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const StyledStarIcon = styled(StarSvgAsComponent)`
  vertical-align: middle;
  width: 100%;
  height: 100%;
`;

type FavoriteButtonProps = {
  isFavorite: boolean;
  className?: string;
  onClick?: (...params: unknown) => unknown;
};

const FavoriteButton = ({ isFavorite, className, onClick = () => {} }: FavoriteButtonProps) => {
  const onButtonClick = useCallback(
    (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      onClick();
    },
    [onClick],
  );

  return (
    <Button className={className} onClick={onButtonClick}>
      <StyledStarIcon isActive={isFavorite} />
    </Button>
  );
};

export default FavoriteButton;
